<div mat-dialog-title>
  <span i18n class="title dialog-title">Замена облицовки пласти</span>
  <button mat-button class="mat-icon-button" (click)="dialogRef.close(undefined)" aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="p-0 pb-0 m-0" fusePerfectScrollbar>
  <ng-container>
    <mat-table #table [dataSource]="dataSource" class="face-band-replacement-table" fusePerfectScrollbar>
      <ng-container matColumnDef="oldFaceBanding">
        <mat-header-cell i18n *matHeaderCellDef>Текущая облицовка пласти</mat-header-cell>
        <mat-cell *matCellDef="let item">
          <p class="text-truncate">
            {{ item.oldMaterial.name }}
          </p>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="newFaceBanding">
        <mat-header-cell i18n *matHeaderCellDef>Новая облицовка пласти</mat-header-cell>
        <mat-cell *matCellDef="let item">
          <mat-form-field class="w-full">
            <mat-select [(ngModel)]="item.newMaterial" #newFaceBandSelect>
              <mat-option [value]="item.oldMaterial">
                {{ item.oldMaterial.name }}
              </mat-option>

              <mat-option *ngFor="let material of otherMaterial" [value]="material">
                {{ material.name }}
              </mat-option>

              <mat-option
                i18n
                [value]="item.newMaterial"
                (click)="setFaceBandFromMatBase(item.newMaterial, newFaceBandSelect)"
                >Другая…</mat-option
              >
            </mat-select>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let item; columns: displayedColumns"></mat-row>
    </mat-table>
  </ng-container>
</div>
<div mat-dialog-actions class="m-0 p-4 flex flex-row justify-end items-center">
  <button i18n mat-raised-button class="mat-accent mr-4" (click)="saveAndClose()">ОК</button>
  <button i18n mat-button (click)="dialogRef.close(undefined)">Отмена</button>
</div>
